if (!window.Eurus.loadedScript.has('nutritional-facts-popup.js')) {
  window.Eurus.loadedScript.add('nutritional-facts-popup.js');
  const nutritionalFactsPopupCache = new Map();

  document.addEventListener('DOMContentLoaded', initializeNutritionalFactsPopup);
  document.addEventListener('shopify:section:load', initializeNutritionalFactsPopup);
  document.addEventListener('change', handleProductSiblingStateChange);

  function initializeNutritionalFactsPopup() {
    assignClickListenersToButton('.nutritional-fact-button', handleNutritionalButtonClick);
    assignClickListenersToButton('.popup-close-btn', handleNutritionalCloseButtonClick);

    syncPopupWithProductSibling();
    assignClickListenersToButton('.nutritional-product-switch', handleNutritionalOptionSwitch);

    const popup = document.querySelector('.nutritional-facts-popup');
    if (popup && popup.dataset.initialized !== 'true') {
      popup.dataset.initialized = 'true';
      popup.addEventListener('click', handleNutritionalPopupBackdropClick);
      popup.addEventListener('cancel', handleNutritionalPopupCancel);
    }
  }

  function assignClickListenersToButton(selector = '', handlerFunction) {
    const multipleButtons = document.querySelectorAll(selector);
    if (multipleButtons?.length) {
      multipleButtons.forEach((element) => {
        element.removeEventListener('click', handlerFunction);
        element.addEventListener('click', handlerFunction);
      });
    }
  }

  function handleNutritionalCloseButtonClick() {
    const popup = document.querySelector('.nutritional-facts-popup');
    if (popup) {
      closeNutritionalPopup(popup);
    }
  }

  async function handleNutritionalButtonClick() {
    const popup = document.querySelector('.nutritional-facts-popup');
    if (popup) {
      await syncPopupWithProductSibling();
      openNutritionalPopup(popup);
    }
  }

  async function handleNutritionalOptionSwitch(event) {
    const button = event?.currentTarget;
    if (button?.dataset?.productUrl) {
      await setActivePopupProduct(button.dataset.productUrl);
      return;
    }

    if (button?.getAttribute('data-switch-id')) {
      await setActivePopupProductById(button.getAttribute('data-switch-id'));
    }
  }

  function handleNutritionalPopupBackdropClick(event) {
    const popup = event?.currentTarget;
    if (popup && event?.target === popup) {
      closeNutritionalPopup(popup);
    }
  }

  function handleNutritionalPopupCancel(event) {
    event.preventDefault();
    const popup = event?.currentTarget;
    if (popup) {
      closeNutritionalPopup(popup);
    }
  }

  function openNutritionalPopup(popup) {
    document.documentElement.classList.add('nutritional-facts-popup-open');
    document.body.classList.add('nutritional-facts-popup-open');

    if (typeof popup.showModal === 'function') {
      if (!popup.open) {
        popup.showModal();
      }
    } else {
      popup.setAttribute('open', 'open');
    }
  }

  function closeNutritionalPopup(popup) {
    document.documentElement.classList.remove('nutritional-facts-popup-open');
    document.body.classList.remove('nutritional-facts-popup-open');

    if (typeof popup.close === 'function' && popup.open) {
      popup.close();
    } else {
      popup.removeAttribute('open');
    }
  }

  function handleProductSiblingStateChange(event) {
    const target = event?.target;
    if (!target) return;

    if (target.matches('.x-block-product-sibling input[data-product-url]')) {
      syncPopupWithProductSibling(target.dataset.productUrl);
      return;
    }

    if (target.matches('.x-block-product-sibling select')) {
      const selectedOption = target.selectedOptions?.[0];
      if (selectedOption?.dataset?.productUrl) {
        syncPopupWithProductSibling(selectedOption.dataset.productUrl);
      }
    }
  }

  async function syncPopupWithProductSibling(activeProductUrl = '') {
    const popup = document.querySelector('.nutritional-facts-popup');
    if (!popup) return;

    rebuildPopupSwitchesFromSiblingControl(popup);
    assignClickListenersToButton('.nutritional-product-switch', handleNutritionalOptionSwitch);

    const selectedProductUrl = normalizeProductPath(
      activeProductUrl ||
      getSelectedSiblingProductUrl() ||
      popup.querySelector('.nutritional-facts-popup__switches')?.dataset?.defaultProductUrl ||
      window.location.pathname
    );

    if (selectedProductUrl) {
      await setActivePopupProduct(selectedProductUrl);
    }
  }

  async function setActivePopupProduct(productUrl) {
    const normalizedUrl = normalizeProductPath(productUrl);
    if (!normalizedUrl) return;

    const popup = document.querySelector('.nutritional-facts-popup');
    if (!popup) return;

    await ensurePopupImageContainer(popup, normalizedUrl);

    let hasMatch = false;
    popup.querySelectorAll('.nutritional-product-switch').forEach((switchButton) => {
      const isActive = normalizeProductPath(switchButton.dataset.productUrl) === normalizedUrl;
      switchButton.classList.toggle('checked', isActive);
      switchButton.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      if (isActive) hasMatch = true;
    });

    popup.querySelectorAll('.nutritional-product-image-container').forEach((container) => {
      const isActive = normalizeProductPath(container.dataset.productUrl) === normalizedUrl;
      container.hidden = !isActive;
    });

    if (!hasMatch) {
      const firstButton = popup.querySelector('.nutritional-product-switch');
      if (firstButton?.dataset?.productUrl) {
        await setActivePopupProduct(firstButton.dataset.productUrl);
      }
    }
  }

  async function setActivePopupProductById(productId) {
    const popup = document.querySelector('.nutritional-facts-popup');
    if (!popup) return;

    const container = popup.querySelector(`.nutritional-product-image-container[data-switch-id="${productId}"]`);
    if (container?.dataset?.productUrl) {
      await setActivePopupProduct(container.dataset.productUrl);
    }
  }

  function rebuildPopupSwitchesFromSiblingControl(popup) {
    const switchContainer = popup.querySelector('.nutritional-facts-popup__switches');
    const siblingBlock = document.querySelector('.x-block-product-sibling');
    if (!switchContainer || !siblingBlock) return;

    if (popup.dataset.isBundlePage === 'true') {
      return;
    }

    const siblingOptions = getSiblingOptionsFromDom(siblingBlock);
    if (!siblingOptions.length) return;

    const selectedProductUrl = normalizeProductPath(
      getSelectedSiblingProductUrl() ||
      switchContainer.dataset.defaultProductUrl ||
      window.location.pathname
    );
    const visibleOptions = siblingOptions.filter((option) => option.productUrl === selectedProductUrl);
    if (!visibleOptions.length) return;

    switchContainer.innerHTML = visibleOptions.map((option) => {
      return `<button class="nutritional-product-switch" type="button" data-product-url="${escapeHtml(option.productUrl)}" aria-pressed="false">${escapeHtml(option.label)}</button>`;
    }).join('');
  }

  function getSiblingOptionsFromDom(siblingBlock) {
    const radioInputs = siblingBlock.querySelectorAll('input[data-product-url]');
    if (radioInputs.length) {
      return Array.from(radioInputs).map((input) => {
        const label = siblingBlock.querySelector(`label[for="${input.id}"]`);
        return {
          productUrl: normalizeProductPath(input.dataset.productUrl),
          label: getSiblingOptionLabel(label, input.value)
        };
      }).filter((option) => option.productUrl && option.label);
    }

    const select = siblingBlock.querySelector('select');
    if (!select) return [];

    return Array.from(select.options).map((option) => ({
      productUrl: normalizeProductPath(option.dataset.productUrl),
      label: option.textContent.trim()
    })).filter((option) => option.productUrl && option.label);
  }

  function getSiblingOptionLabel(label, fallbackLabel = '') {
    if (!label) return fallbackLabel;

    return (
      label.getAttribute('aria-label') ||
      label.getAttribute('title') ||
      label.textContent.trim() ||
      fallbackLabel
    );
  }

  async function ensurePopupImageContainer(popup, normalizedUrl) {
    const existingContainer = popup.querySelector(`.nutritional-product-image-container[data-product-url="${normalizedUrl}"]`);
    if (existingContainer) return existingContainer;

    const fetchedMarkup = await fetchNutritionalImageMarkup(normalizedUrl);
    if (!fetchedMarkup) return null;

    const contentContainer = popup.querySelector('.popup-product-content');
    if (!contentContainer) return null;

    contentContainer.insertAdjacentHTML('beforeend', fetchedMarkup);
    return contentContainer.querySelector(`.nutritional-product-image-container[data-product-url="${normalizedUrl}"]`);
  }

  async function fetchNutritionalImageMarkup(normalizedUrl) {
    if (nutritionalFactsPopupCache.has(normalizedUrl)) {
      return nutritionalFactsPopupCache.get(normalizedUrl);
    }

    try {
      const response = await fetch(normalizedUrl, { credentials: 'same-origin' });
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const popup = html.querySelector('.nutritional-facts-popup');
      if (!popup) {
        nutritionalFactsPopupCache.set(normalizedUrl, '');
        return '';
      }

      const matchingContainer = popup.querySelector(`.nutritional-product-image-container[data-product-url="${normalizedUrl}"]`);
      const isBundlePage = popup.dataset.isBundlePage === 'true';
      const fallbackContainer = isBundlePage ? popup.querySelector('.nutritional-product-image-container') : null;
      const container = matchingContainer || fallbackContainer;

      if (!container) {
        nutritionalFactsPopupCache.set(normalizedUrl, '');
        return '';
      }

      container.setAttribute('data-product-url', normalizedUrl);
      container.hidden = true;

      const markup = container.outerHTML;
      nutritionalFactsPopupCache.set(normalizedUrl, markup);
      return markup;
    } catch (error) {
      nutritionalFactsPopupCache.set(normalizedUrl, '');
      return '';
    }
  }

  function getSelectedSiblingProductUrl() {
    const checkedInput = document.querySelector('.x-block-product-sibling input[data-product-url]:checked');
    if (checkedInput?.dataset?.productUrl) {
      return checkedInput.dataset.productUrl;
    }

    const selectedOption = document.querySelector('.x-block-product-sibling select option[data-product-url]:checked');
    if (selectedOption?.dataset?.productUrl) {
      return selectedOption.dataset.productUrl;
    }

    const siblingSelect = document.querySelector('.x-block-product-sibling select');
    const fallbackOption = siblingSelect?.selectedOptions?.[0];
    if (fallbackOption?.dataset?.productUrl) {
      return fallbackOption.dataset.productUrl;
    }

    return '';
  }

  function normalizeProductPath(url) {
    if (!url) return '';

    try {
      return new URL(url, window.location.origin).pathname.replace(/\/$/, '') || '/';
    } catch (error) {
      return String(url).split('?')[0].replace(window.location.origin, '').replace(/\/$/, '') || '/';
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }
}
